// extracted by mini-css-extract-plugin
export var hidden = "_4x-1";
export var leftPanel = "_4x-2";
export var readonlyInspector = "_4x-3";
export var rightPanel = "_4x-0";